import React from 'react';
import AuditTable from '../../components/Audit/AuditTable';

const Audit: React.FC = () => {
  return (
    <AuditTable />
  );
};

export default Audit;
